import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  forwardRef,
  input,
  viewChild,
} from '@angular/core';
import { ControlValueAccessorBase } from '@core/control-value-accessor-base';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslatePipe } from '@core/pipes';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'sc-input-string',
  imports: [FormsModule, TranslatePipe, AsyncPipe],
  templateUrl: './input-string.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => InputStringComponent),
    },
  ],
})
export class InputStringComponent
  extends ControlValueAccessorBase<string>
  implements AfterViewInit
{
  placeholder = input<string>('');
  id = input<string>(null);
  autofocus = input(false);
  errorMessage = input<string>('');

  inputRef = viewChild<ElementRef>('input');

  public isFocused = false;

  ngAfterViewInit() {
    if (this.autofocus()) {
      this.inputRef().nativeElement.focus();
    }
  }

  public onFocus() {
    this.isFocused = true;
  }

  public onBlur() {
    this.isFocused = false;
  }
}
